// *******************************************************************************
// Form : Step Form
// *******************************************************************************
const stepFormElem = document.querySelector('.step-form');

if (stepFormElem) {
  const createAndAppendDiv = (parent, className, textContent) => {
    const div = document.createElement('div');
    div.classList.add(className);
    div.textContent = textContent || '';
    parent.appendChild(div);
  };

  const handleStepForm = (form, formAction) => {
    const formParent = form.closest('[data-step-form-parent]');
    const allFormSteps = formParent.querySelectorAll('.step-form__step');
    const allStepIndicator = formParent.querySelectorAll('.step-form__indicator-btn');
    const nextButton = formParent.querySelector('.step-form__next-step');
    const prevButton = formParent.querySelector('.step-form__prev-step');
    const submitButtonText = nextButton.getAttribute(['data-submit-text']);
    const formAlertError = formParent.querySelector('.step-form__alert-error');
    const nextButtonText = nextButton.querySelector('.btn__text').innerHTML;
    const allForms = [];
    const allStepData = [];
    const allStepRequiredData = [];
    const emailError = getEmailError(form);

    let currentStepIndex = 0;

    const toggleStep = (index, active) => {
      const step = allFormSteps[index];
      const stepIndicator = allStepIndicator[index];

      FormValidation.utils.classSet(step, {
        'is-active': active,
      });
      FormValidation.utils.classSet(stepIndicator, {
        'is-active': active,
      });
      FormValidation.utils.classSet(stepIndicator, {
        'is-completed': active,
      });
    };

    const markCompleted = (index) => {
      const stepIndicator = allStepIndicator[index];
      stepIndicator.classList.add('is-completed');
    };

    const moveNextStep = async () => {
      if (currentStepIndex < allForms.length) {
        const currentForm = allForms[currentStepIndex];
        const status = await currentForm.validate();
        if (status !== 'Valid') {
          return;
        }

        let nextIndex = currentStepIndex + 1;

        while (nextIndex < allFormSteps.length && allFormSteps[nextIndex].classList.contains('hide')) {
          nextIndex++;
        }

        if (nextIndex < allFormSteps.length) {
          toggleStep(currentStepIndex, false);
          currentStepIndex = nextIndex;
          toggleStep(currentStepIndex, true);
          prevButton.classList.remove('hide');
        }

        if (currentStepIndex === allFormSteps.length - 1) {
          nextButton.innerHTML = submitButtonText;
          const formSteps = formParent.querySelectorAll('.step-form__step');
          const resultsContainer = formParent.querySelector('.step-form__results');
          resultsContainer.innerHTML = '';

          formSteps.forEach((step) => {
            const stepBlock = document.createElement('div');
            stepBlock.classList.add('step-form__results-block');

            step.querySelectorAll('.step-form__item').forEach((row) => {
              const rowLabel = (row.getAttribute('data-label') || '').replace('*', '');
              let inputValue = '';
              let isSpecifications = false;

              if (row.classList.contains('has-checkbox')) {
                const checkbox = row.querySelector('.checkbox input');
                if (
                  checkbox.id === 'inquiry_form_privacy_policy' ||
                  checkbox.id === 'inquiry_form_newsletter_subscription'
                ) {
                  return;
                }
              }

              if (row.classList.contains('has-toggle')) {
                const toggleInput = row.querySelector('.mod-toggle__input');
                inputValue = toggleInput.checked
                  ? toggleInput.getAttribute('data-yes-text')
                  : toggleInput.getAttribute('data-no-text');
              } else if (row.classList.contains('has-checkbox')) {
                const checkbox = row.querySelector('.checkbox input');
                inputValue = checkbox.checked
                  ? checkbox.getAttribute('data-yes-text')
                  : checkbox.getAttribute('data-no-text');
              } else if (row.classList.contains('has-dropdown')) {
                const dropdown = row.querySelector('.dropdown input:checked');
                inputValue = dropdown.value;
              } else if (row.classList.contains('has-upload-box')) {
                const fileUpload = row.querySelector('.upload-box input');
                inputValue = fileUpload.files[0].name;
              } else if (row.classList.contains('has-input-group')) {
                const checkedInputs = row.querySelectorAll('input:checked');

                if (!checkedInputs) {
                  return;
                }

                inputValue = joinActiveItems(checkedInputs);
              } else if (row.classList.contains('has-specifications')) {
                const selectedDropdown = row.querySelector('.dropdown input:checked');
                const inputValues = row.querySelectorAll('.mod-input input');

                if (!selectedDropdown || inputValues.length <= 0) {
                  return;
                }

                isSpecifications = true;
              } else if (row.classList.contains('has-input')) {
                const inputField = row.querySelector('.mod-input__field');
                if (inputField && inputField.value.length > 0) {
                  inputValue = inputField.value;
                } else {
                  return;
                }
              } else {
                inputValue = '';
              }

              const resultItem = document.createElement('div');
              resultItem.classList.add('step-form__results-item');

              // Create a wrapper div with class step-form__results-item-inner
              const resultItemInner = document.createElement('div');
              resultItemInner.classList.add('step-form__results-item-inner');

              // Add the title (rowLabel) between resultItem and resultItemInner
              const resultItemTitle = document.createElement('div');
              resultItemTitle.classList.add('step-form__results-item-title');
              resultItemTitle.textContent = rowLabel;

              resultItem.appendChild(resultItemTitle);

              if (isSpecifications) {
                resultItem.classList.add('specifications-result');

                row.querySelectorAll('.specifications-block__items--default').forEach((item) => {
                  const selectedDropdown = item.querySelector('.dropdown input:checked');
                  const inputValues = item.querySelectorAll('.mod-input input');
                  const labels = item.querySelectorAll('.specifications-block__item');

                  // Create and append a separate row for labels
                  const specificationsLabelRow = document.createElement('div');
                  specificationsLabelRow.classList.add('specifications-result__label-row');

                  labels.forEach((label) => {
                    createAndAppendDiv(
                      specificationsLabelRow,
                      'specifications-result__label',
                      label.getAttribute('data-label'),
                    );
                  });

                  resultItemInner.appendChild(specificationsLabelRow);

                  // Create and append a separate row for values
                  const specificationsRow = document.createElement('div');
                  specificationsRow.classList.add('specifications-result__row');

                  createAndAppendDiv(specificationsRow, 'specifications-result__item', selectedDropdown?.value);

                  inputValues.forEach((input) => {
                    createAndAppendDiv(specificationsRow, 'specifications-result__item', input.value);
                  });

                  resultItemInner.appendChild(specificationsRow);
                });
              } else {
                resultItemInner.innerHTML = `
                <div class="step-form__results-right">${inputValue}</div>
              `;
              }

              resultItem.appendChild(resultItemInner); // Append the inner wrapper with contents

              stepBlock.appendChild(resultItem);
            });

            resultsContainer.appendChild(stepBlock);
          });
        }

        scrollTop(formParent);
      }
    };

    const moveBackStep = () => {
      if (currentStepIndex > 0) {
        allStepIndicator.forEach((indicator) => indicator.classList.remove('is-active'));

        toggleStep(currentStepIndex, false);
        currentStepIndex--;
        toggleStep(currentStepIndex, true);

        if (currentStepIndex === 0) {
          prevButton.classList.add('hide');
        }

        nextButton.innerHTML = nextButtonText;
        scrollTop(formParent);
      }
    };

    allFormSteps.forEach((step, index) => {
      const emailFields = step.querySelectorAll('input[type="email"]'); // Get all email fields

      const fieldValidators = {};
      emailFields.forEach((field) => {
        const fieldName = field.name;

        if (fieldName) {
          fieldValidators[fieldName] = {
            validators: {
              callback: {
                message: emailError,
                callback(input) {
                  return validateEmail(input.value);
                },
              },
            },
          };
        }
      });

      const fv = FormValidation.formValidation(step, {
        locale: 'sl_SI',
        localization: FormValidation.locales.sl_SI,
        fields: fieldValidators,
        plugins: {
          message: new FormValidation.plugins.Message({
            container: (field, element) =>
              element.closest('.mod-input,.checkbox,.radio-button,.dropdown,.mod-toggle,.upload-box'),
          }),
          declarative: new FormValidation.plugins.Declarative({
            html5Input: true,
          }),
          trigger: new FormValidation.plugins.Trigger({
            event: 'submit',
          }),
          excluded: new FormValidation.plugins.Excluded(),
          submitButton: new FormValidation.plugins.SubmitButton(),
        },
      })
        .on('core.element.validated', (e) => {
          if (e.element.hasAttribute('required')) {
            const value = fv.getElementValue(e.field, e.element);
            const container = FormValidation.utils.closest(
              e.element,
              '.mod-input,.checkbox,.radio-button,.dropdown,.mod-toggle,.upload-box',
            );
            FormValidation.utils.classSet(container, {
              'is-validation-failed': value === '' || !e.valid,
            });
          }
        })
        .on('core.form.valid', () => {
          grecaptcha.ready(async () => {
            formParent.classList.add('show-loader');

            try {
              const stepData = getFormValue(step, fv);
              allStepData.push(JSON.parse(stepData.inputs));
              allStepRequiredData.push(JSON.parse(stepData.requiredInputs));

              if (index === allFormSteps.length - 1) {
                const inputs = {};
                const requiredInputs = {};

                for (const key in allStepData) {
                  if (!isNaN(key)) {
                    Object.assign(inputs, allStepData[key]);
                  }
                }

                for (const key in allStepRequiredData) {
                  if (!isNaN(key)) {
                    Object.assign(requiredInputs, allStepRequiredData[key]);
                  }
                }

                const files = {};
                Array.from(filesToUpload).forEach((file, index) => {
                  files[`files_${index + 1}`] = file.file;
                });

                await onFormSubmit({
                  formData: {
                    ...files,
                    inputs: JSON.stringify(inputs),
                    requiredInputs: JSON.stringify(requiredInputs),
                    lang: localData.lang,
                    id: localData.id,
                    formType: form.getAttribute('id'),
                  },
                  recaptchaKey: form.querySelector('[data-sitekey]').getAttribute('data-sitekey'),
                  recaptchaAction: formAction,
                });
              }

              formParent.classList.remove('show-loader');

              if (index === allFormSteps.length - 1) {
                formParent.classList.add('show-thankyou');
                if (formParent.closest('.form-modal')) {
                  const formModalEle = formParent.closest('.form-modal');
                  formModalEle.classList.add('show-thankyou');
                }
              } else {
                toggleStep(index, false);
                if (index + 1 < allFormSteps.length) {
                  toggleStep(index + 1, true);
                }
              }
              markCompleted(index);
            } catch (error) {
              console.error(error);
              formParent.classList.remove('show-loader');
              formParent.classList.add('show-error');
              formAlertError.classList.remove('hide');
              formAlertError.innerHTML = error.response.data.data.msg;
            }
          });
        });

      allForms.push(fv);

      attachEvent('.specifications-block__add', 'click', (btn) => {
        const parent = btn.target.closest('.specifications-block');
        const lastAddedRow = parent.querySelector('.last-added');

        const inputs = lastAddedRow?.querySelectorAll('input');

        inputs?.forEach((input) => {
          const field = input.getAttribute('data-fv-name');
          fv.addField(field, {
            validators: {},
          });
        });
      });
    });

    nextButton.addEventListener('click', () => {
      moveNextStep();

      const selectedModalInput = formParent.querySelector('.radio-button-group--modals input:checked');
      if (selectedModalInput) {
        formParent
          .querySelectorAll('.radio-button-group__list-item.hide .is-validation-failed')
          .forEach((item) => item.classList.remove('is-validation-failed'));

        formParent.querySelector('.radio-button-group--modals')?.classList.remove('failed');
      }
    });

    prevButton.addEventListener('click', moveBackStep);
  };

  document.addEventListener('DOMContentLoaded', () => {
    ['steps_form', 'inquiry_form'].forEach((id) => {
      const form = document.querySelector(`#${id}`);
      if (form !== null) {
        const formAction = form.querySelector('[data-action]').value;
        handleStepForm(form, formAction, id);
      }
    });
  });

  ['steps_form', 'inquiry_form'].forEach((id) => {
    const form = document.querySelector(`#${id}`);
    if (form !== null) {
      window.addEventListener('pageshow', (event) => {
        const navigationEntries = performance.getEntriesByType('navigation');
        if (
          event.persisted ||
          (window.performance && navigationEntries.length > 0 && navigationEntries[0].type === 'back_forward')
        ) {
          window.location.reload();
        }
      });
    }
  });

  // Filter Windows
  const filterItems = document.querySelectorAll('[data-filter-item]');

  const applyFilters = () => {
    const filterValues = Array.from(document.querySelectorAll('[data-filter]:checked')).map((input) =>
      input.getAttribute('data-filter'),
    );

    filterItems.forEach((item) => {
      const itemValues = item.getAttribute('data-filter-item').split(',');
      const parent = item.closest('[data-item]');
      const radioGroup = parent.closest('.radio-button-group');

      parent.classList.toggle('hide', !filterValues.every((value) => itemValues.includes(value)));

      radioGroup.classList.toggle('empty', !radioGroup.querySelectorAll('[data-item]:not(.hide)').length);
    });
  };

  if (filterItems.length) {
    applyFilters();
    document.querySelectorAll('[data-filter]').forEach((filter) => filter.addEventListener('change', applyFilters));

    const helpToChoose = document.querySelector('#i_need_help_choosing');
    helpToChoose?.addEventListener('change', applyFilters);
  }

  // Toggle disable class
  const checkedDisabledItems = document.querySelectorAll('[data-checked-disabled]');
  const uncheckedDisabledItems = document.querySelectorAll('[data-unchecked-disabled]');

  if (checkedDisabledItems.length > 0 || uncheckedDisabledItems.length > 0) {
    const toggleClass = (element, className, toggle) => {
      element.classList.toggle(className, toggle);
    };

    const updateDisabledState = () => {
      const disabledElements = new Map();

      // Process checked-disabled inputs
      checkedDisabledItems.forEach((item) => {
        const ids = item.dataset.checkedDisabled.split(',').map((id) => id.trim());
        ids.forEach((id) => {
          const target = document.getElementById(id);
          const parent = target ? target.closest('[data-input-group-item]') : null;
          if (parent && item.checked) {
            target.checked = false;
            disabledElements.set(parent, true);
          }
        });
      });

      // Process unchecked-disabled inputs
      uncheckedDisabledItems.forEach((item) => {
        const ids = item.dataset.uncheckedDisabled.split(',').map((id) => id.trim());
        ids.forEach((id) => {
          const target = document.getElementById(id);
          const parent = target ? target.closest('[data-input-group-item]') : null;
          if (parent && !item.checked) {
            disabledElements.set(parent, true);
          }
        });
      });

      const allTargets = document.querySelectorAll('[data-input-group-item]');
      allTargets.forEach((el) => toggleClass(el, 'is-disabled', false));

      disabledElements.forEach((_, element) => toggleClass(element, 'is-disabled', true));
    };

    updateDisabledState();

    [...checkedDisabledItems, ...uncheckedDisabledItems].forEach((input) => {
      input.addEventListener('change', updateDisabledState);
    });
  }
}
